import { useState, useEffect } from "react";

export const useQRCodeHandlers = (links) => {
  const [showQRCode, setShowQRCode] = useState(false);
  const [selectedLink, setSelectedLink] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");

  // Inicializar automáticamente con el primer idioma cuando se proporcionan los links
  useEffect(() => {
    if (links && Object.keys(links).length > 0 && !selectedLink) {
      const firstLanguage = Object.keys(links)[0];
      const firstUrl = links[firstLanguage];
      setSelectedLink(firstUrl);
      setSelectedLanguage(firstLanguage);
      setShowQRCode(true);
    }
  }, [links, selectedLink]);

  const handleQRCodeClick = (url, language) => {
    setSelectedLink(url);
    setSelectedLanguage(language);
    setShowQRCode(true);
  };

  const handleCloseQRCode = () => {
    setShowQRCode(false);
    setSelectedLink("");
    setSelectedLanguage("");
  };

  return {
    showQRCode,
    selectedLink,
    selectedLanguage,
    handleQRCodeClick,
    handleCloseQRCode,
  };
};
